var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.54551 11.9118H13.0934C13.2005 11.9118 13.3033 11.8692 13.3791 11.7934C13.4549 11.7176 13.4975 11.6149 13.4975 11.5076C13.4975 11.4005 13.4549 11.2977 13.3791 11.2219C13.3033 11.1461 13.2005 11.1035 13.0934 11.1035H5.3538L4.54551 11.9118ZM12.1047 3.43919L13.2347 2.30917V2.30926C13.2953 2.24857 13.3293 2.16637 13.3293 2.08066C13.3293 1.99494 13.2953 1.91266 13.2347 1.85206L11.565 0.18305C11.5044 0.122448 11.4222 0.0883789 11.3364 0.0883789C11.2507 0.0883789 11.1685 0.122446 11.1079 0.18305L9.97787 1.31274L12.1047 3.43919ZM9.21865 2.0722L1.50244 9.78863V11.7826V11.7825C1.50244 11.8168 1.51609 11.8497 1.54028 11.874C1.56455 11.8983 1.59745 11.9119 1.63176 11.9119H3.63116L11.345 4.19847L9.21865 2.0722Z",
    fill: "#A4A4A4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.37bed24b9c799185ae962985642c1f06.svg";
export { ForwardRef as ReactComponent };